// "Checkout now" beside the bag button in the product card (snippets/buy-buttons.liquid). It adds the trim with
// everything the form carries (variant, jacket, fit check link or photo) and goes straight to checkout.
//
// It submits the product form, so The Fitting's own check runs first (snippets/fur-trim-quiz.liquid listens in the
// capture phase on the section): an unfinished fit is stopped there and the card asks for it; a photo still being
// shrunk is waited for and the form submitted again. Only then does this take over, on the form itself, before the
// theme's add to bag (on <product-form>), which would open the bag drawer instead. The button follows the bag
// button's disabled state, which The Fitting sets.

const root = window.Shopify?.routes?.root || '/';
const INTENT_MS = 20000;

function setUp(button) {
  const form = button.form;
  const bag = form?.querySelector('.af-bag-button');
  if (!form || !bag || button.dataset.afReady) return;
  button.dataset.afReady = 'true';

  const mirror = () => {
    button.disabled = bag.disabled;
  };
  new MutationObserver(mirror).observe(bag, { attributes: true, attributeFilter: ['disabled'] });
  mirror();

  let intent = 0;
  // Back from checkout, Safari shows the page as it was left (still busy): make the button usable again
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    intent = 0;
    button.removeAttribute('aria-busy');
    mirror();
  });
  button.addEventListener('click', () => {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    intent = Date.now();
    if (form.requestSubmit) form.requestSubmit();
    else bag.click();
  });

  form.addEventListener('submit', async (event) => {
    // A press on a real submit button (the bag button, the sticky bar) is a normal add to bag
    if (event.submitter) {
      intent = 0;
      return;
    }
    if (!intent || Date.now() - intent > INTENT_MS || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    intent = 0;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || '');
      // The bag, its count and dot catch up, in case checkout is slow to open or they come back
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.location.href = `${root}checkout`;
    } catch (error) {
      button.removeAttribute('aria-busy');
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message || 'Something went wrong. Please try again.' } }));
    }
  });
}

document.querySelectorAll('[data-af-checkout-now]').forEach(setUp);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-af-checkout-now]').forEach(setUp));
